module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-flow-03-5b24847753a87a2a5e2b4539208d5801.png";